import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { includes } from 'lodash';
import { Grid, Container, CircularProgress } from '@mui/material';
import { translateEvents } from '../../../utils/events';

import * as SHIPMENT_STATUS from '../../../constants/shipmentStatus';

import DefaultProfile from './DefaultProfile';
import CustomProfile from './CustomProfile';
import { getCookie } from '../../../utils/cookie';

const TEMPLATES = {
  DefaultProfile: DefaultProfile,
  AxleHire: CustomProfile,
};

function ProfileContainer(props) {
  const [coordinates, setCoordinates] = useState(null);
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { classes, store } = props;
  const { deliveryStore, podStore } = store;
  const { delivery, step, loadingDelivery, dialogOpened, dialogLoading, loadingProfile, settings, trackingCode, editedDeliveryData, pageTheme } =
    deliveryStore;
  // no-dd-sa:javascript-code-style/assignment-name
  const client_profile = delivery?.client_profile;

  useEffect(() => {
    if (params?.tracking_code && !includes(['404', 'error'], params.tracking_code)) {
      window.zESettings = {
        messenger: {
          contactForm: {
            tags: [params.tracking_code],
          },
        },
      };

      try {
        if (window.zE) {
          window.zE('messenger:on', 'open', () => {
            window.zE('messenger', 'chat:addTags', [params.tracking_code]);
          });
        }
      } catch (error) {
        /* empty */
      }

      if (getCookie('axl_shipment_token')) {
        deliveryStore.updateField('token', getCookie('axl_shipment_token'));
      }
      deliveryStore.getDelivery(params.tracking_code, (res) => {
        if (res.status === 404) {
          if (includes(location.pathname, '/noredirect/')) {
            window.location.href = `/404`;
          } else {
            window.location.href = `/`;
          }
        }

        if (res.data?.shipment && res.data.shipment.dropoff_address) {
          const { shipment } = res.data;
          setCoordinates({ latitude: shipment.dropoff_address.lat, longitude: shipment.dropoff_address.lng });
        }
      });
    }

    if (window.location.href.indexOf('manage=true') > -1) {
      deliveryStore.openDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.tracking_code, location.pathname]);

  const closeDialog = () => {
    if (deliveryStore.lastStep) {
      deliveryStore.updateField('lastStep', false);
      podStore.updateField('isPreviewImage', true);
    }
    deliveryStore.closeDialog();
    if (window.location.href.indexOf('manage=true') > -1) {
      navigate(`/${deliveryStore.trackingCode}`, { replace: true });
    }
  };

  if (loadingDelivery || loadingProfile) {
    return (
      <Container maxWidth="lg">
        <Grid style={{ height: '100vh' }} container alignItems="center" justifyContent="center">
          <CircularProgress color="primary" />
        </Grid>
      </Container>
    );
  }

  if (!delivery) return null;

  const { client, shipment, courier, signRequired, outbound_events } = delivery;

  const milestones = outbound_events.map((e) => e.milestone).filter((m) => m);
  const milestone = milestones[0] || SHIPMENT_STATUS.PROCESSING;
  const isDelivered = milestone === SHIPMENT_STATUS.DELIVERED;

  const progress = SHIPMENT_STATUS.progressByStatus(pageTheme);

  const translatedEvents = translateEvents(outbound_events || [], shipment);

  const key = client_profile?.template;
  const dataProps = client_profile?.config;
  const Component = TEMPLATES[key] || TEMPLATES.DefaultProfile;

  return (
    <Component
      store={store}
      client={client}
      client_profile={client_profile}
      classes={classes}
      shipment={shipment}
      progress={progress}
      signRequired={signRequired}
      isDelivered={isDelivered}
      milestone={milestone}
      translatedEvents={translatedEvents}
      courier={courier}
      delivery={delivery}
      settings={settings}
      trackingCode={trackingCode}
      deliveryStore={deliveryStore}
      editedDeliveryData={editedDeliveryData}
      dialogStep={step}
      dialogOpened={dialogOpened}
      dialogLoading={dialogLoading}
      closeDialog={closeDialog}
      coordinates={coordinates}
      podStore={podStore}
      navigate={navigate}
      {...dataProps}
    />
  );
}

const ComposeComponent = compose(inject('store'), observer)(ProfileContainer);

export default ComposeComponent;
